module.exports = __webpack_public_path__ + "3d5bb8687d3e8a19e3c10959106828c3.png";